import { Main, ViewButton } from 'components/ActionStyles/ActionStyles'
import DriveDetails from 'modules/Roles/ViewRole/TwoDriveDrawer/TwoDriveTable/DriveDetailsDrawe/index'
import React, { useState } from 'react'

const DriveActionDropdown = ({
  driveData,
  getDriveRoleMetrics,
  driveRoleMetrics,
  setTwoDriveDrawer,
}) => {
  const [driveDetailDrawer, setDriveDetailDrawer] = useState(false)
  const [detailsLoading, setDetailsLoading] = useState(false)

  const onClickView = async driveId => {
    const { status } = await getDriveRoleMetrics({
      setLoading: setDetailsLoading,
      driveId: driveId,
    })
    if (status >= 200 && status < 300) {
      setDriveDetailDrawer(true)
    }
  }

  return (
    <>
      <Main>
        <ViewButton
          height="32px"
          text={'Edit'}
          onClick={() => onClickView(driveData?.id)}
        />
      </Main>
      {driveDetailDrawer && (
        <DriveDetails
          driveDetails={driveDetailDrawer}
          setDriveDetails={setDriveDetailDrawer}
          driveData={driveData}
          metricsData={driveRoleMetrics}
          setTwoDriveDrawer={setTwoDriveDrawer}
          detailsLoading={detailsLoading}
        />
      )}
    </>
  )
}

export default DriveActionDropdown
